import { Card, Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import FormCheckboxField from '../../../FormFields/FormCheckboxField';
import { formCardStyle } from '../../../TransitionStyles';
import { REPORTS } from '../../../formQuestionsEnum';

ChecklistForm.propTypes = {
  permissions: PropTypes.object,
};

export const CHECKLIST_FIELDS = {
  HasTimeclockLaborData: 'HasTimeclockLaborData',
  HasEMARData: 'HasEMARData',
};

export default function ChecklistForm({ permissions }) {
  return (
    REPORTS.CHECKLIST.id in permissions && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          Checklist
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
        <Grid container spacing={1.5}>
          <Grid item xs={12}>
            <FormCheckboxField
              fieldName={`checklist.${CHECKLIST_FIELDS.HasTimeclockLaborData}`}
              fieldAttributes={{
                isEditable: permissions[REPORTS.CHECKLIST.id],
                label: 'Timeclock/Labor Data',
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <FormCheckboxField
              fieldName={`checklist.${CHECKLIST_FIELDS.HasEMARData}`}
              fieldAttributes={{
                isEditable: permissions[REPORTS.CHECKLIST.id],
                label: 'EMAR Data',
              }}
            />
          </Grid>
        </Grid>
      </Card>
    )
  );
}
